import * as React from 'react';
import SvgIcon,{SvgIconProps} from '@mui/material/SvgIcon';

const CalendarIcon = ({sx,...props}: SvgIconProps) => {

    return(
        <SvgIcon viewBox="0 0 22 22" sx={{height:'22px' , width:'22px',...sx}} {...props}>
            <path d="M19.25 9.16683H2.75M14.6667 1.8335V5.50016M7.33333 1.8335V5.50016M7.15 20.1668H14.85C16.3901 20.1668 17.1602 20.1668 17.7485 19.8671C18.2659 19.6034 18.6866 19.1827 18.9503 18.6653C19.25 18.077 19.25 17.307 19.25 15.7668V8.06683C19.25 6.52668 19.25 5.75661 18.9503 5.16836C18.6866 4.65091 18.2659 4.23021 17.7485 3.96656C17.1602 3.66683 16.3901 3.66683 14.85 3.66683H7.15C5.60986 3.66683 4.83978 3.66683 4.25153 3.96656C3.73408 4.23021 3.31338 4.65091 3.04973 5.16836C2.75 5.75661 2.75 6.52668 2.75 8.06683V15.7668C2.75 17.307 2.75 18.077 3.04973 18.6653C3.31338 19.1827 3.73408 19.6034 4.25153 19.8671C4.83978 20.1668 5.60986 20.1668 7.15 20.1668Z"
                  stroke="#14191F"
                  strokeOpacity="0.4"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
        </SvgIcon>
    );
};

export default CalendarIcon;


